export const meta = {
  id: "FW-06",
  name: "Coinwright",
  slug: "coinwright",
  title: "Coinwright — a Fable World: fintech launch page",
  description:
    "An original fintech landing page designed by Fable: full-bleed cinema panels, a dated page-timeline, deep green and gold leaf."
} as const;

export default meta;
